module.exports = __webpack_public_path__ + "img/home_tm.8e95980a.png";